import React from 'react';
import './StupidSystemDesigns.css';

const gamesDesignCode = String.raw`
#include <iostream>
#include <vector>
#include <unordered_map>
#include <string>

using namespace std;

enum class GameState { TURN1, TURN2, COMPLETE };

class Player {
    int id;
    string name;

public:
    Player(int pId, string pName) : id(pId), name(pName) {}

    int getId() const { return id; }
    string getName() const { return name; }
};

class Game {
    int gameId;
    vector<vector<int>> board;
    int id1, id2;
    GameState state;

public:
    Game(int gId, int pId1, int pId2) {
        gameId = gId;
        board.assign(3, vector<int>(3, 0));
        id1 = pId1;
        id2 = pId2;
        state = GameState::TURN1;
    }

    bool validPlayer(int id) {
        if (state == GameState::COMPLETE) return false;
        if (id == id1 && state == GameState::TURN1) return true;
        if (id == id2 && state == GameState::TURN2) return true;
        return false;
    }

    bool validMove(int row, int col) {
        // Boundary check
        if (row < 0 || row >= 3 || col < 0 || col >= 3) return false;
        // Occupied cell check
        if (board[row][col] != 0) return false;
        return true;
    }

    bool checkWin() {
        // Check Rows and Columns
        for (int i = 0; i < 3; i++) {
            if (board[i][0] != 0 && board[i][0] == board[i][1] && board[i][1] == board[i][2]) return true;
            if (board[0][i] != 0 && board[0][i] == board[1][i] && board[1][i] == board[2][i]) return true;
        }
        // Check Diagonals
        if (board[0][0] != 0 && board[0][0] == board[1][1] && board[1][1] == board[2][2]) return true;
        if (board[0][2] != 0 && board[0][2] == board[1][1] && board[1][1] == board[2][0]) return true;

        return false;
    }

    bool checkComplete() {
        // Check if no empty slots left
        for (int i = 0; i < 3; i++) {
            for (int j = 0; j < 3; j++) {
                if (board[i][j] == 0) return false;
            }
        }
        return true;
    }

    void updateState(int id) {
        if (id == id1) state = GameState::TURN2;
        else state = GameState::TURN1;
    }

    void printBoard() {
        cout << "------------- \n";
        for (int i = 0; i < 3; i++) {
            cout << "| ";
            for (int j = 0; j < 3; j++) {
                char symbol = ' ';
                if (board[i][j] == 1) symbol = 'X';
                else if (board[i][j] == 2) symbol = 'O';
                cout << symbol << " | ";
            }
            cout << "\n------------- \n";
        }
    }

    void makeMove(int pId, int row, int col) {
        if (state == GameState::COMPLETE) {
            cout << "[Game " << gameId << "] Action Failed: Game is already completed!\n";
            return;
        }

        if (!validPlayer(pId)) {
            cout << "[Game " << gameId << "] Action Failed: Not Player " << pId << "'s turn!\n";
            return;
        }

        if (!validMove(row, col)) {
            cout << "[Game " << gameId << "] Action Failed: Invalid cell (" << row << ", " << col << ") - occupied or out of bounds!\n";
            return;
        }

        // Apply move
        board[row][col] = (pId == id1) ? 1 : 2;
        cout << "[Game " << gameId << "] Player " << pId << " played at (" << row << ", " << col << "):\n";
        printBoard();

        if (checkWin()) {
            cout << " [Game " << gameId << "] Player " << pId << " WINS THE GAME!\n\n";
            state = GameState::COMPLETE;
        } 
        else if (checkComplete()) {
            cout << " [Game " << gameId << "] GAME ENDED IN A DRAW!\n\n";
            state = GameState::COMPLETE;
        } 
        else {
            updateState(pId);
            int nextPlayer = (state == GameState::TURN1) ? id1 : id2;
            cout << "Next Turn: Player " << nextPlayer << "\n\n";
        }
    }
};

class Games {
    int playerCounter = 1;
    int gameCounter = 1;
    unordered_map<int, Player*> players;
    unordered_map<int, Game*> games;

public:
    Games() = default;

    ~Games() {
        for (auto& pair : players) delete pair.second;
        for (auto& pair : games) delete pair.second;
    }

    int addPlayer(string name) {
        int pId = playerCounter++;
        Player* player = new Player(pId, name);
        players[pId] = player;
        cout << "Registered Player: " << name << " with ID: " << pId << "\n";
        return pId;
    }

    int addGame(int p1, int p2) {
        if (!players.count(p1) || !players.count(p2)) {
            cout << "Error: One or both player IDs invalid.\n";
            return -1;
        }
        int gameId = gameCounter++;
        Game* game = new Game(gameId, p1, p2);
        games[gameId] = game;
        cout << "Created Game " << gameId << " between " 
             << players[p1]->getName() << " (ID: " << p1 << ") and " 
             << players[p2]->getName() << " (ID: " << p2 << ")\n\n";
        return gameId;
    }

    void makeMove(int gId, int pId, int row, int col) {
        if (!games.count(gId)) {
            cout << "Error: Game ID " << gId << " does not exist.\n";
            return;
        }
        games[gId]->makeMove(pId, row, col);
    }
};

int main() {
    Games manager;

    cout << "=== INITIALIZING PLAYERS ===\n";
    int p1 = manager.addPlayer("Alice");
    int p2 = manager.addPlayer("Bob");
    int p3 = manager.addPlayer("Charlie");
    cout << "\n";

    cout << "=== GAME 1: ALICE vs BOB (WIN SCENARIO) ===\n";
    int g1 = manager.addGame(p1, p2);

    // Alice = 1 (X), Bob = 2 (O)
    manager.makeMove(g1, p1, 0, 0); // Alice
    manager.makeMove(g1, p2, 1, 0); // Bob
    
    // Test Invalid Moves
    manager.makeMove(g1, p2, 1, 1); // Bob out of turn
    manager.makeMove(g1, p1, 0, 0); // Alice playing occupied cell
    
    manager.makeMove(g1, p1, 0, 1); // Alice
    manager.makeMove(g1, p2, 1, 1); // Bob
    manager.makeMove(g1, p1, 0, 2); // Alice wins diagonally/top row!

    // Attempting move after game ends
    manager.makeMove(g1, p2, 2, 2);

    cout << "=== GAME 2: BOB vs CHARLIE (DRAW SCENARIO) ===\n";
    int g2 = manager.addGame(p2, p3);

    // Bob = 2 (X), Charlie = 3 (O)
    manager.makeMove(g2, p2, 0, 0);
    manager.makeMove(g2, p3, 0, 1);
    manager.makeMove(g2, p2, 0, 2);
    manager.makeMove(g2, p3, 1, 1);
    manager.makeMove(g2, p2, 1, 0);
    manager.makeMove(g2, p3, 1, 2);
    manager.makeMove(g2, p2, 2, 1);
    manager.makeMove(g2, p3, 2, 0);
    manager.makeMove(g2, p2, 2, 2); // Last cell filled -> Draw

    return 0;
}

`;

function GamesDesign({ theme, onBackClick }) {
    return (
        <div className={`app ${theme}`}>
            <main className="system-design-page">
                <section className="system-designs-header-section">
                    <div className="system-designs-header">
                        <div className="system-designs-header-copy">
                            <h1>Games Low Level Design</h1>
                            <p className="system-designs-subtitle">
                                A simple foundation for running games, validating moves, and keeping every match independent.
                            </p>
                        </div>
                        <button className="back-btn" onClick={onBackClick}>Back to Designs</button>
                    </div>
                </section>

                <section className="system-designs-content">
                    <div className="system-design-article">
                        <div className="design-section">
                            <h2>Requirements</h2>
                            <ul>
                                <li>Users can start and play a game.</li>
                                <li>Players can make only valid moves for the current game state.</li>
                                <li>A game completes when its winning, losing, or draw condition is reached.</li>
                                <li>Multiple games can be played at the same time without sharing state.</li>
                            </ul>
                        </div>

                        <div className="design-section">
                            <h2>Requirements Satisfied</h2>
                            <ul>
                                <li><strong>Game lifecycle:</strong> Create a separate game session with its own players, board, turn, and status.</li>
                                <li><strong>Move validation:</strong> Check that the game is active, the player has the turn, and the move is legal before changing state.</li>
                                <li><strong>Completion handling:</strong> Evaluate the updated state after every valid move and mark the game as won, lost, or drawn when appropriate.</li>
                                <li><strong>Concurrent matches:</strong> Store games by a unique game ID so actions in one match cannot affect another.</li>
                            </ul>
                        </div>

                        <div className="design-section">
                            <h2>Why State Patterns Matter</h2>
                            <p className="system-design-description">
                                Games are driven by a sequence of state changes: a game starts, a player makes a move, the turn changes, and eventually the game completes. A state pattern gives each phase clear rules and keeps invalid actions out of the system. For example, a completed game should reject new moves, while an active game should accept only moves allowed by its current state.
                            </p>
                            <p className="system-design-description">
                                Recording each game state, or the moves that produce it, makes the design easier to debug, replay, and recover. It also keeps simultaneous games isolated because every state transition is associated with one game ID. A state machine or snapshot history can therefore provide a reliable source of truth instead of scattering turn and completion checks throughout the code.
                            </p>
                        </div>

                        <div className="design-section">
                            <h2>Working Logic</h2>
                            <pre className="design-code-block"><code>{gamesDesignCode}</code></pre>
                        </div>
                    </div>

                    <div className="system-designs-footer-note">
                        Unfortunately I do not have anything witty to say in this page's footer. byeee!
                    </div>

                    <button className="back-btn" onClick={onBackClick}>Back to Designs</button>
                </section>
            </main>

            <footer className="footer">
                <p>© 2026 StupidDesigns.com. All rights reserved. Not that anyone actually wants them.</p>
            </footer>
        </div>
    );
}

export default GamesDesign;
